import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

/**
 * Handles `#session_id=...` fragment from Emergent Managed Auth.
 * Exchanges via backend, sets cookie, then navigates to intended route or feed.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sid = match ? decodeURIComponent(match[1]) : null;
    if (!sid) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        await authApi.createSession(sid);
        await refresh();
      } catch (e) {
        console.error("Auth session exchange failed", e);
      } finally {
        // Clear hash and navigate
        let target = "/";
        try {
          const intent = JSON.parse(sessionStorage.getItem("nobsgs_post_login_intent") || "null");
          if (intent?.redirect) target = intent.redirect;
          sessionStorage.removeItem("nobsgs_post_login_intent");
        } catch {}
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate(target, { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#111622] flex items-center justify-center" data-testid="auth-callback">
      <div className="rounded-2xl bg-[#1A2232] border border-[#26334D] px-6 py-5 shadow-[0_10px_30px_rgba(15,23,42,0.06)]">
        <p className="text-sm text-[#94A3B8]">Finishing sign-in…</p>
      </div>
    </div>
  );
}
